class OneRosterApiService {
  constructor(config, httpDim) {
    this.config = config;
    this.httpDim = httpDim;
    this.oneRosterApiUrl = `${this.config.apiRoot}/oneRoster`;
  }

  validateIntegrations(oneRosterCreds) {
    let url = `${this.oneRosterApiUrl}/validate?url=${oneRosterCreds.url.value}&key=${oneRosterCreds.consumerKey.value}&secret=${oneRosterCreds.consumerSecret.value}`;
    return this.httpDim.get(url);
  }

}

OneRosterApiService.$inject = ['config', 'httpDim'];

export
default OneRosterApiService;



// WEBPACK FOOTER //
// ./app/common/oneRosterApi/oneRosterApi.service.js